export enum DealLinesStatus {
  BOOKING_STATUS_FAILED = 'BOOKING_STATUS_FAILED',
  LINE_WITH_OUT_OF_CHARGE_FRAMES = 'LINE_WITH_OUT_OF_CHARGE_FRAMES',
}

export interface DealLinesIconProps {
  status: DealLinesStatus;
}
